import { AvailLANG, DBAnswerSpec } from "interfaces";
import { useContext } from "react";
import { ControlledTextField } from "Components/HookForm/ControlledTextField";
import { VStack } from "Components/Layouts";
import { FLEFormContext } from "../hooks/FLEContexts";
import { store } from "static";
import { Control, FieldValues, Path } from "react-hook-form";

interface IProps<TFieldValues extends FieldValues = FieldValues> {
  langs?: AvailLANG[];
  name: Path<TFieldValues>;
  control: Control<TFieldValues, any>;
  disabled?: boolean;
}

export function ControlledMultilangAnswerFeilds<T extends FieldValues = FieldValues>({ langs = Object.values(AvailLANG), name, control, disabled, ...props }: IProps<T>) {
  const defaultLang = store.sysInfo.Language.default;
  const formCtxt = useContext(FLEFormContext);

  return (
    <VStack width="100%">
      {langs.map((lang) => {
        return (
          <ControlledTextField<T>
            //
            name={`${name}.text.${lang}.0` as Path<T>}
            control={control}
            label={lang}
            key={lang}
            required={lang == defaultLang}
            rules={{
              required: lang == defaultLang ? "This field is required" : undefined,
            }}
            disabled={disabled || formCtxt?.mode == "Info"}
            fullWidth
            multiline
            {...props}
          />
        );
      })}
    </VStack>
  );
}
